import React, { useState, useEffect,useRef } from 'react';
import './ProjectMasterList.css';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import Select, { components } from 'react-select';
import DatePicker from 'react-datepicker';
import { format, parseISO } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import { showToast } from '../toastUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import html2pdf from 'html2pdf.js';
import FullscreenLoader from '../FullscreenLoader';
import { queuedApiFetch, apiFetch } from '../api';
import * as XLSX from 'xlsx';

function ProjectMasterList() {

  const contentRef = useRef();
//'PM_Name', 'PD_Name'
  const columnOptions = [ //'Proj_Number',
    'Sno','SC_Number', 'Proj_Name', 'Proj_ShortName', 'PM_Name_New', 'PD_Name_New',
    'Proj_Dept', 'Proj_Address', 'CPRS_Number', 'CPRS_Approval_Date', 'Proj_Approved_Budget',
    'Proj_Cost', 'Construction_Cost', 'GFA', 'Proj_StartDate', 'Proj_EndDate',
    'Exptd_Cons_StartDate', 'Exptd_Cons_EndDate', 'Exptd_Main_Contractor_Calling_Date',
    'Exptd_Main_Contract_Award_Date', 'Contractual_Cons_StartDate', 'Contractual_Cons_EndDate',
    'Actual_Cons_EndDate', 'Proj_Stage', 'Proj_Progress_Status', 'Potential_Extn_of_Time',
    'Granted_Extn_of_Time', 'CSC_Date', 'Handover_Date', 'TOP_Date', 'DLP_Expiry_Date',
    'Consultant_Names', 'Contractor_Names', 'Building_Code', 'Exptd_appnmt_of_Consultants',
    'Exptd_Handover_Date', 'Exptd_Authority_submissions', 'Actual_Authority_submissions',
    'Contractor','Arch', 'CS', 'ME', 'QS','Remarks','tender_ref_no','Submission_Remarks', 
    'Project_Status_Remarks'
  ];

  
  const getUserDetails = localStorage.getItem('userDetails');
  const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';
  const userId = userDetails ? userDetails.id : '';
  const getUserAccess = userDetails ? userDetails.access_level : '';
  const [rows, setRows] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState(columnOptions);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);  
  const [sortDirection, setSortDirection] = useState('asc'); 
  const getUserEmail = localStorage.getItem('userEmail');

  // const fetchWBSData = () => {
  //   setIsLoading(true);
  //   const requestOptions = {
  //     method: 'GET',
  //     //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
  //   };

  //   queuedApiFetch('/project/getprojectmaster', requestOptions)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
  //         setRows(data.data);
  //         setIsLoading(false);
  //       }
  //     })
  //     .catch((error) => console.error('Error fetching data:', error))
  //     .finally(() => setIsLoading(false));
  // };


  

  const fetchProjectMasterDetails = async () => {
    setIsLoading(true);
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };

    try {
      const response = await queuedApiFetch(`/project/get_master_projectlist?userid=${userId}&email_id=${getUserEmail}`,
        requestOptions
      );
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        setRows(data.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (userId) {
      fetchProjectMasterDetails();
    }
  }, [userId]);

  // const handleExport = async () => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Export');    
  //   const orderedColumns = selectedColumns.includes('Sno')
  //     ? ['Sno', ...selectedColumns.filter(col => col !== 'Sno')]
  //     : selectedColumns;

  //   worksheet.columns = orderedColumns.map(column => {
  //     const header = labelMapping[column] || column.replace(/_/g, ' ').toUpperCase();
  //     return { header, key: column };
  //   });

  //   rows.forEach(row => {
  //     const rowData = {};

  //     orderedColumns.forEach(column => {
  //       let value = row[column] || '';
  //       const dateValue = new Date(value);

  //       if (
  //         value && !isNaN(dateValue.getTime()) &&
  //         typeof value === 'string' && value.trim() !== '' &&
  //         /\d{4}-\d{2}-\d{2}/.test(value)
  //       ) {
  //         // Format dates
  //         //rowData[column] = dateValue.toLocaleDateString('en-US');
  //         const day = String(dateValue.getDate()).padStart(2, '0');
  //         const month = String(dateValue.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  //         const year = dateValue.getFullYear();
  //         rowData[column] = `${day}-${month}-${year}`;
  //       } else if (
  //         ['Proj_Approved_Budget', 'Proj_Cost', 'Construction_Cost'].includes(column) &&
  //         typeof value === 'number'
  //       ) {
  //         // Format currency columns as $XXX,XXX.00
  //         rowData[column] = new Intl.NumberFormat('en-US', {
  //           style: 'currency',
  //           currency: 'USD',
  //           minimumFractionDigits: 0,
  //           maximumFractionDigits: 0
  //         }).format(value);
  //       } else {
  //         // Other columns
  //         rowData[column] = value;
  //       }
  //     });

  //     worksheet.addRow(rowData);
  //   });

  //   // Export to Excel file
  //   workbook.xlsx.writeBuffer().then(buffer => {
  //     saveAs(new Blob([buffer]), 'ProjectMasterList.xlsx');
  //   });
  // };  

  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Export');

    const orderedColumns = selectedColumns.includes('Sno')
      ? ['Sno', ...selectedColumns.filter(col => col !== 'Sno')]
      : selectedColumns;

    worksheet.columns = orderedColumns.map(column => {
      const header = labelMapping[column] || column.replace(/_/g, ' ').toUpperCase();
      return { header, key: column };
    });

    // Initialize auto-increment counter for "Sno"
    let snoCounter = 1;

    rows.forEach(row => {
      const rowData = {};

      orderedColumns.forEach(column => {
        if (column === 'Sno') {
          // Set auto-incremented value for "Sno"
          rowData[column] = snoCounter++;
        } else {
          let value = row[column] || '';
          const dateValue = new Date(value);

          if (
            value && !isNaN(dateValue.getTime()) &&
            typeof value === 'string' && value.trim() !== '' &&
            /\d{4}-\d{2}-\d{2}/.test(value)
          ) {
            // Format dates to dd-mm-yyyy
            const day = String(dateValue.getDate()).padStart(2, '0');
            const month = String(dateValue.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const year = dateValue.getFullYear();
            rowData[column] = `${day}-${month}-${year}`;
          } else if (
            ['Proj_Approved_Budget', 'Proj_Cost', 'Construction_Cost'].includes(column) &&
            typeof value === 'number'
          ) {
            // Format currency columns as $XXX,XXX.00
            rowData[column] = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(value);
          } else {
            // Other columns
            rowData[column] = value;
          }
        }
      });

      worksheet.addRow(rowData);
    });

    // Export to Excel file
    workbook.xlsx.writeBuffer().then(buffer => {
      saveAs(new Blob([buffer]), 'ProjectMasterList.xlsx');
    });
  };


  const labelMapping = {
    Sno: 'S.No',
    SC_Number: 'SC / SN No.',
    Proj_Name: 'Project Name',
    Proj_ShortName: 'Project Short Name',
    // Proj_Number: 'Project Number',
    // PM_Name: 'Project Manager Name',
    // PD_Name: 'Project Director Name',
    PM_Name_New: 'Project Manager Name',
    PD_Name_New: 'Project Director Name',
    Proj_Dept: 'Project Department',
    Proj_Address: 'Project Address',
    CPRS_Number: 'CPRS Number',
    CPRS_Approval_Date: 'CPRS Approval Date',
    Proj_Approved_Budget: 'Project Approved Budget',
    Proj_Cost: 'Project Cost',
    Construction_Cost: 'Construction Cost',
    GFA: 'GFA (Gross Floor Area)',
    Proj_StartDate: 'Project Start Date',
    Proj_EndDate: 'Project End Date',
    Exptd_Cons_StartDate: 'Expected Construction Start Date',
    Exptd_Cons_EndDate: 'Expected Construction End Date',
    Exptd_Main_Contractor_Calling_Date: 'Expected Main Contractor Calling Date',
    Exptd_Main_Contract_Award_Date: 'Expected Main Contract Award Date',
    Contractual_Cons_StartDate: 'Contractual Construction Start Date',
    Contractual_Cons_EndDate: 'Contractual Construction End Date',
    Actual_Cons_EndDate: 'Actual Construction End Date',
    Proj_Stage: 'Project Stage',
    Proj_Progress_Status: 'Project Progress Status',
    Potential_Extn_of_Time: 'Potential Extension of Time (Days)',
    Granted_Extn_of_Time: 'Granted Extension of Time (Days)',
    CSC_Date: 'CSC Date (Certificate of Statutory Completion)',
    Handover_Date: 'Handover Date (Actual)',
    TOP_Date: 'TOP Date (Temporary Occupation Permit)',
    DLP_Expiry_Date: 'DLP Expiry Date (Defects Liability Period)',
    Consultant_Names: 'Consultant Names',
    Contractor_Names: 'Contractor Names',
    Building_Code: 'Building Code',
    Exptd_appnmt_of_Consultants: 'Expected Appointment of Consultants',
    Exptd_Handover_Date: 'Expected Handover Date',
    Exptd_Authority_submissions: 'Detailed Design and Authority Submission Start Date',
    Actual_Authority_submissions: 'Detailed Design and Authority Submission End Date',
    Contractor: 'Contractor',
    Arch: 'Arch',
    CS: 'CS',
    ME: 'M&E',
    QS: 'QS',
    Remarks:'Remarks',
    tender_ref_no:'Tender_Ref_No',
    Submission_Remarks: 'Submission Remarks',
    Project_Status_Remarks: 'Project Status Remarks'
  };

  const options = [
    { value: 'selectAll', label: 'Select All' },
    ...columnOptions.map(column => ({
      value: column,
      label: labelMapping[column] || column.replace(/_/g, ' ').toUpperCase()
    }))
  ];

  const handleColumnChange = (selectedOptions) => {
    if (selectedOptions.some(option => option.value === 'selectAll')) {
      if (selectedColumns.length < columnOptions.length) {
        setSelectedColumns(columnOptions); // Select all columns
      } else {
        setSelectedColumns([]); // Deselect all columns
      }
    } else {
      setSelectedColumns(selectedOptions.map(option => option.value));
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: '100%',  // Adjust width as needed
      borderColor: state.isFocused ? '#B0B0B0' : '#E0E0E0',  // Light gray border color on focus
      borderRadius: '8px',
      padding: '5px',
      boxShadow: state.isFocused ? '0 0 5px rgba(176, 176, 176, 0.5)' : 'none', // Light gray focus box-shadow
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: '5px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)', // Lighter shadow
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '10px',
      backgroundColor: state.isSelected ? '#B0B0B0' : state.isFocused ? '#F8F8F8' : '#fff', // Lighter gray background when selected
      color: state.isSelected ? '#fff' : '#333', // White text on selected
      borderRadius: '4px',
      cursor: 'pointer',
      ':active': {
        backgroundColor: '#B0B0B0', // Active state lighter gray background
        color: '#fff',
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#B0B0B0',  // Lighter gray background for multi-value
      borderRadius: '4px',
      color: '#fff',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#fff',
      ':hover': {
        backgroundColor: '#D3D3D3',  // Lighter gray color for remove icon hover
      },
    }),
  };


  const handleEditField = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  // const updateProjectMasterList = () => {
  //   setSubmitLoading(true);
  //   if (!submitLoading) {
  //     const sendData = rows;
  //     const requestOptions = {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'ngrok-skip-browser-warning': '69420'
  //       },
  //       body: JSON.stringify(sendData),
  //     };
  //     queuedApiFetch('/project/updateprojectmaster', requestOptions)
  //       .then((response) => response.json())
  //       .then((result) => {
  //         // alert(result.message || 'Data saved successfully');
  //         showToast.success('Data saved successfully');
  //         setSubmitLoading(false);          
  //       })
  //       .catch((error) => console.error('Error saving data:', error));
  //   }
  // };   

  const updateProjectMasterList = async () => {
    // Avoid submitting if already in progress
    if (submitLoading) return;

    setSubmitLoading(true);

    const sendData = rows;
    const requestOptions = {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'application/json',
      //   'ngrok-skip-browser-warning': '69420',
      // },
      body: JSON.stringify(sendData),
    };

    try {
      const response = await queuedApiFetch(`/project/updateprojectmaster`,
        requestOptions
      );
      const result = await response;

      // Check if the response status is successful
      if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
        showToast.success('Data saved successfully');
      } else {
        showToast.error(result.apistatus.Status_Description || 'Error occurred. Please try again.');
      }
    } catch (error) {
      console.error('Error saving data:', error);
      showToast.error('Something went wrong. Please try again.');
    } finally {
      setSubmitLoading(false); // Ensure loading state is reset after completion
    }
  };

  const CustomValueContainer = ({ children, ...props }) => {
    const selectedOptions = props.getValue();

    let displayValue;
    if (selectedOptions.length <= 2) {
      displayValue = selectedOptions.map(opt => opt.label).join(', ');
    } else {
      const displayedLabels = selectedOptions.slice(0, 2).map(opt => opt.label);
      const moreCount = selectedOptions.length - 2;
      displayValue = `${displayedLabels.join(', ')} + ${moreCount} more`;
    }

    return (
      <components.ValueContainer {...props}>
        <span>{displayValue}</span>
        {children[1]}
      </components.ValueContainer>
    );
  };

  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          style={{ marginRight: 8 }}
        />
        <label>{props.label}</label>
      </components.Option>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatDate_n = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    // const day = String(date.getDate()).padStart(2, '0');
    // const month = String(date.getMonth() + 1).padStart(2, '0');
    // const year = date.getFullYear();
    const formattedDate = (date==null)?date:format(date, 'dd/MMM/yyyy');

    // return `${day}-${month}-${year}`;
    return formattedDate;
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
  };


      // for sorting icon implementation 
  
      const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

      const sortRows = (rows, config) => {
        const sortedRows = [...rows];
        if (config.key) {
          sortedRows.sort((a, b) => {
            let aValue = a[config.key];
            let bValue = b[config.key];
    
            // Handle sorting for SC_Number field by extracting numbers after '_'
            if (config.key === 'SC_Number') {
              const extractNumber = (value) => {
                const match = value.match(/_(\d+)$/); // Match numbers after the last '_'
                return match ? parseInt(match[1], 10) : 0; // Return the number after '_' or 0 if not found
              };
    
              aValue = extractNumber(aValue);
              bValue = extractNumber(bValue);
            } else {
              // For other fields (e.g., Proj_Name), perform normal string comparison
              if (typeof aValue === 'string') {
                aValue = aValue.toLowerCase();
              }
              if (typeof bValue === 'string') {
                bValue = bValue.toLowerCase();
              }
            }
    
            // Compare the values and sort in the specified direction
            if (aValue < bValue) return config.direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return config.direction === 'asc' ? 1 : -1;
            return 0;
          });
        }
        return sortedRows;
      };

      const handleSort = (key) => {
  let direction = 'asc';
  if (sortConfig.key === key && sortConfig.direction === 'asc') {
    direction = 'desc';
  }
  setSortConfig({ key, direction });

  const sortedRows = [...rows].sort((a, b) => {
    let aValue = a[key] ?? '';
    let bValue = b[key] ?? '';

    // Special handling for SC_Number (extract trailing numbers)
    if (key === 'SC_Number') {
      const extractNumber = (val) => {
        if (!val) return 0;
        const match = val.match(/_(\d+)$/);
        return match ? parseInt(match[1], 10) : parseInt(val.replace(/\D/g, ''), 10) || 0;
      };
      aValue = extractNumber(aValue);
      bValue = extractNumber(bValue);
    } else {
      // Default string comparison
      aValue = aValue.toString().toLowerCase();
      bValue = bValue.toString().toLowerCase();
    }

    if (aValue < bValue) return direction === 'asc' ? -1 : 1;
    if (aValue > bValue) return direction === 'asc' ? 1 : -1;
    return 0;
  });

  setRows(sortedRows);
};

      // const handleSort = () => {
      //   const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
      //   setSortDirection(newSortDirection);
    
      //   const sortedRows = [...rows].sort((a, b) => {
      //     const projNameA = a.Proj_Name.toLowerCase();
      //     const projNameB = b.Proj_Name.toLowerCase();
    
      //     if (newSortDirection === 'asc') {
      //       return projNameA.localeCompare(projNameB); // Ascending order
      //     } else {
      //       return projNameB.localeCompare(projNameA); // Descending order
      //     }
      //   });
    
      //   setRows(sortedRows);
      // };

  const handleDownloadPDF = () => {
    setIsLoading(true);
    const element = contentRef.current;

    // Clone element and set wider width for full scroll capture
    const cloned = element.cloneNode(true);
    cloned.style.width = element.scrollWidth + "px";
    cloned.style.height = element.scrollHeight + "px";

    // Invisible container to render content without affecting layout
    const container = document.createElement("div");
    container.style.position = "absolute";
    container.style.left = "-9999px";
    container.style.top = "0";
    container.appendChild(cloned);
    document.body.appendChild(container);

    const opt = {
      margin: 0,
      filename: "ProjectMasterList.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 1,
        scrollX: 0,
        scrollY: 0,
        width: element.scrollWidth, // capture full scroll width
        windowWidth: element.scrollWidth,
        height: element.scrollHeight, // capture full scroll height
        windowHeight: element.scrollHeight,
      },
      jsPDF: {
        unit: "px",
        format: [element.scrollWidth, element.scrollHeight, element.offsetHeight],
        orientation: element.scrollWidth > element.scrollHeight ? "landscape" : "portrait",
        //orientation: "landscape",
      },
    };

    html2pdf().set(opt).from(cloned).save()
      .then(() => {
        // Clean up
        document.body.removeChild(container);
      });
    setIsLoading(false);
  };



 // Mapping of special field transformations
  const transformFieldValue = (key, value) => {
    switch (key) {
      case 'Proj_Progress_Status':
        return (Number(value) * 100).toFixed(2); // Multiply & format
      // Add more case statements for other computed fields if needed
      default:
        return value;
    }
  };


  const handleDownloadCSV = () => {

    // const csvRows = [
    //   ['S.No', 'SC Number', 'Project Name', 'Project Short Name', 'Project Manager Name', 'Project Director Name', 'Project Department', 'Project Address', 'CPRS Number', 'CPRS Approval Date', 'Project Approved Budget', 'Project Cost', 'Construction Cost', 'GFA (Gross Floor Area)', 'Project Start Date', 'Project End Date', 'Expected Construction Start Date', 'Expected Construction End Date', 'Expected Main Contractor Calling Date', 'Expected Main Contract Award Date', 'Contractual Construction Start Date', 'Contractual Construction End Date', 'Actual Construction End Date', 'Project Stage', 'Project Progress Status','Potential Extension of Time (Days)', 'Granted Extension of Time (Days)', 'CSC Date (Certificate of Statutory Completion)', 'Handover Date (Actual)', 'TOP Date (Temporary Occupation Permit)', 'DLP Expiry Date (Defects Liability Period)', 'Consultant Names', 'Contractor Names', 'Building Code', 'Expected Appointment of Consultants', 'Expected Handover Date', 'Detailed Design and Authority Submission Start Date', 'Detailed Design and Authority Submission End Date', 'Contractor', 'Arch', 'CS', 'M&E', 'QS', 'Remarks', 'Tender_Ref_No','Submission Remarks','Project Status Remarks'], // header
    //   ...rows.map(row => [row.Sno,row.SC_Number, row.Proj_Name, row.Proj_ShortName, row.PM_Name, row.PD_Name, row.Proj_Dept, row.Proj_Address, row.CPRS_Number, row.CPRS_Approval_Date, row.Proj_Approved_Budget, row.Proj_Cost, row.Construction_Cost, row.GFA, row.Proj_StartDate, row.Proj_EndDate,row.Exptd_Cons_StartDate, row.Exptd_Cons_EndDate, row.Exptd_Main_Contractor_Calling_Date, row.Exptd_Main_Contract_Award_Date, row.Contractual_Cons_StartDate, row.Contractual_Cons_EndDate, row.Actual_Cons_EndDate, row.Proj_Stage, row.Proj_Progress_Status, row.Potential_Extn_of_Time, row.Granted_Extn_of_Time, row.CSC_Date, row.Handover_Date, row.TOP_Date, row. DLP_Expiry_Date, row.Consultant_Names, row.Contractor_Names, row.Building_Code, row.Exptd_appnmt_of_Consultants, row. Exptd_Handover_Date, row.Exptd_Authority_submissions, row. Actual_Authority_submissions, row.Contractor, row.Arch, row.CS, row.ME, row.QS, row.Remarks, row.tender_ref_no, row.Submission_Remarks, row.Project_Status_Remarks])
    // ];

    const keys = Object.keys(labelMapping);
    // const csvRows = [
    //   keys.map(key => labelMapping[key]), // header row
    //   ...rows.map(row => keys.map(key => row[key] ?? '')) // data rows
    // ];

    // Create CSV content
    // const csvRows = [
    //   keys.map(key => `"${labelMapping[key]}"`), // Header row with labels
    //   ...rows.map(row => keys.map(key => escapeCSVValue(row[key]))) // Data rows with sanitization
    // ];
    const csvRows = [
      keys.map(key => escapeCSVValue(labelMapping[key])), // Header row
      ...rows.map(row =>
        keys.map(key =>
          escapeCSVValue(transformFieldValue(key, row[key]))
        )
      )
    ];

    const csvContent = csvRows.map(e => e.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'ProjectMasterList.csv';
    link.click();

    URL.revokeObjectURL(url); // clean up
  };

  const escapeCSVValue = (value) => {
    if (value == null) return '';

    let str = String(value).trim();

    // Normalize all unicode to block obfuscation (e.g., curly quotes → straight quotes)
    str = str.normalize('NFKC');

    // Escape double quotes (RFC-compliant)
    str = str.replace(/"/g, '""');

    // Protect against formula injection
    if (/^[=+\-@]/.test(str)) {
      // Completely neutralize potential formula, don’t just prefix with `'`
      // Option 1: prefix space (safe and minimal disruption)
      str = ` ${str}`;
    }

    // Extra protection: remove known dangerous formula fragments (if any remain)
    const lowerStr = str.toLowerCase();
    const dangerousKeywords = ['cmd|', '/c', 'powershell', 'shell', 'cmd.exe', 'notepad', 'calc'];
    for (const keyword of dangerousKeywords) {
      if (lowerStr.includes(keyword)) {
        // Completely strip the content or replace it
        //str = '[removed for safety]';
        str = '';
        break;
      }
    }

    return `"${str}"`;
  };

 

  
  const handleDownloadXLSX = () => {
    // console.log("Selected Columns",selectedColumns);
    // const keys = Object.keys(labelMapping);
    const keys = selectedColumns;
    // Build worksheet data
    const worksheetData = [
      keys.map(key => labelMapping[key]), // Header row with mapped labels
      ...rows.map(row =>
        keys.map(key =>
          transformFieldValue(key, sanitizeXLSXValue(row[key]))
        )
      )
    ];

    // Create worksheet & workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");

    // Export to file
    XLSX.writeFile(workbook, "ProjectMasterList.xlsx");
  };

  // Sanitize cell values for safety & consistency
  const sanitizeXLSXValue = (value) => {
    if (value == null) return '';

    let str = String(value).trim();
    str = str.normalize('NFKC'); // normalize unicode

    // Neutralize potential formula injection
    if (/^[=+\-@]/.test(str)) {
      str = ` ${str}`; // prefix with safe space
    }

    // Extra protection against dangerous keywords
    const lowerStr = str.toLowerCase();
    const dangerousKeywords = ['cmd|', '/c', 'powershell', 'shell', 'cmd.exe', 'notepad', 'calc'];
    for (const keyword of dangerousKeywords) {
      if (lowerStr.includes(keyword)) {
        str = '';
        break;
      }
    }

    return str;
  };


  return (
    <div className="bodywrapp" style={{ width: '100%' }}>
      {isLoading && <FullscreenLoader />} 
      <div className="header" style={{ width: '95%' }}>
        <div className="projectwrap">
          <div className="addwbswrap" style={{background: '#e7e6e6'}}>
            <button disabled={rows && rows.length == 0 ? true : false} onClick={handleDownloadXLSX}>Export Excel</button>
            <button style={{marginLeft: '30px'}} disabled={rows && rows.length == 0 ? true : false} onClick={handleDownloadPDF}>Export PDF</button>
          </div>
          {/* <button id="submit" disabled={submitLoading || rows.length == 0 ? true : false} onClick={updateProjectMasterList}>Submit</button> */}
        </div>
      </div>

      <div id="pm_list">

        <div className="filter-wrap" style={{ width: '95%' }}>
          <Select
            isMulti
            name="columns"
            options={options}
            value={options.filter(option => selectedColumns.includes(option.value))}
            onChange={handleColumnChange}
            closeMenuOnSelect={false}
            placeholder="Select Columns"
            hideSelectedOptions={false}
            styles={customStyles}
            components={{
              ValueContainer: CustomValueContainer,
              Option: CustomOption,
            }}
          />
        </div>            
        <div ref={contentRef} className="tablewrap" style={{ width: '90%', overflowX: 'auto', overflowY: 'auto', height: 'calc(100vh - 276px)' }}>
          <table id="wbsTable">
            <thead>
              <tr>
                {selectedColumns.includes('Sno') && <th className="description-column">S.No</th>}
                {/* {selectedColumns.includes('SC_Number') && <th className="description-column">SC / SN No.</th>} */}
                {/* {selectedColumns.includes('SC_Number') && (
                               <th onClick={handleSort}>
                                 SC / SN No.
                                 {sortDirection === 'asc' ? (
                                   <FontAwesomeIcon icon={faSortUp} />
                                 ) : (
                                   <FontAwesomeIcon icon={faSortDown} />
                                 )}
                               </th>
                             )}
                           {selectedColumns.includes('Proj_Name') && (
                               <th onClick={handleSort}>
                                 Project&nbsp;Name&nbsp;&nbsp;
                                 {sortDirection === 'asc' ? (
                                   <FontAwesomeIcon icon={faSortUp} />
                                 ) : (
                                   <FontAwesomeIcon icon={faSortDown} />
                                 )}
                               </th>
                             )} */}
                {selectedColumns.includes('SC_Number') && (
                  <th onClick={() => handleSort('SC_Number')} style={{ cursor: 'pointer' }}>
                    SC / SN No.&nbsp;
                    {sortConfig.key === 'SC_Number' ? (
                      sortConfig.direction === 'asc' ? (
                        <FontAwesomeIcon icon={faSortUp} />
                      ) : (
                        <FontAwesomeIcon icon={faSortDown} />
                      )
                    ) : (
                      <FontAwesomeIcon icon={faSort} />
                    )}
                  </th>
                )}

                {selectedColumns.includes('Proj_Name') && (
                  <th onClick={() => handleSort('Proj_Name')} style={{ cursor: 'pointer' }}>
                    Project&nbsp;Name&nbsp;
                    {sortConfig.key === 'Proj_Name' ? (
                      sortConfig.direction === 'asc' ? (
                        <FontAwesomeIcon icon={faSortUp} />
                      ) : (
                        <FontAwesomeIcon icon={faSortDown} />
                      )
                    ) : (
                      <FontAwesomeIcon icon={faSort} />
                    )}
                  </th>
                )}
                {selectedColumns.includes('Proj_ShortName') && <th className="description-column">Project Short Name</th>}
                {/* {selectedColumns.includes('Proj_Number') && <th className="description-column">Project Number</th>} */}
                {/* {selectedColumns.includes('PM_Name') && <th className="description-column">Project Manager Name</th>}
                {selectedColumns.includes('PD_Name') && <th className="description-column">Project Director Name</th>} */}
                {selectedColumns.includes('PM_Name_New') && <th className="description-column">Project Manager Name</th>}
                {selectedColumns.includes('PD_Name_New') && <th className="description-column">Project Director Name</th>}
                {selectedColumns.includes('Proj_Dept') && <th className="description-column">Project Department</th>}
                {selectedColumns.includes('Proj_Address') && <th className="description-column">Project Address</th>}
                {selectedColumns.includes('CPRS_Number') && <th className="description-column">CPRS Number</th>}
                {selectedColumns.includes('CPRS_Approval_Date') && <th style={{ minWidth: '100px' }} className="description-column">CPRS Approval Date</th>}
                {selectedColumns.includes('Proj_Approved_Budget') && <th className="description-column">Project Approved Budget</th>}
                {selectedColumns.includes('Proj_Cost') && <th className="description-column">Project Cost</th>}
                {selectedColumns.includes('Construction_Cost') && <th className="description-column">Construction Cost</th>}
                {selectedColumns.includes('GFA') && <th className="description-column">GFA (Gross Floor Area)</th>}
                {selectedColumns.includes('Proj_StartDate') && <th style={{ minWidth: '100px' }} className="description-column">Project Start Date</th>}
                {selectedColumns.includes('Proj_EndDate') && <th style={{ minWidth: '100px' }} className="description-column">Project End Date</th>}
                {selectedColumns.includes('Exptd_Cons_StartDate') && <th className="description-column">Expected Construction Start Date</th>}
                {selectedColumns.includes('Exptd_Cons_EndDate') && <th className="description-column">Expected Construction End Date</th>}
                {selectedColumns.includes('Exptd_Main_Contractor_Calling_Date') && <th className="description-column">Expected Main Contractor Calling Date</th>}
                {selectedColumns.includes('Exptd_Main_Contract_Award_Date') && <th className="description-column">Expected Main Contract Award Date</th>}
                {selectedColumns.includes('Contractual_Cons_StartDate') && <th className="description-column">Contractual Construction Start Date</th>}
                {selectedColumns.includes('Contractual_Cons_EndDate') && <th className="description-column">Contractual Construction End Date</th>}
                {selectedColumns.includes('Actual_Cons_EndDate') && <th className="description-column">Actual Construction End Date</th>}
                {selectedColumns.includes('Proj_Stage') && <th className="description-column">Project Stage</th>}
                {selectedColumns.includes('Proj_Progress_Status') && <th className="description-column">Project Progress Status</th>}
                {selectedColumns.includes('Potential_Extn_of_Time') && <th className="description-column">Potential Extension of Time (Days)</th>}
                {selectedColumns.includes('Granted_Extn_of_Time') && <th className="description-column">Granted Extension of Time (Days)</th>}
                {selectedColumns.includes('CSC_Date') && <th className="description-column">CSC Date (Certificate of Statutory Completion)</th>}
                {selectedColumns.includes('Handover_Date') && <th className="description-column">Handover Date (Actual)</th>}
                {selectedColumns.includes('TOP_Date') && <th className="description-column">TOP Date (Temporary Occupation Permit)</th>}
                {selectedColumns.includes('DLP_Expiry_Date') && <th className="description-column">DLP Expiry Date (Defects Liability Period)</th>}
                {selectedColumns.includes('Consultant_Names') && <th className="description-column">Consultant Names</th>}
                {selectedColumns.includes('Contractor_Names') && <th className="description-column">Contractor Names</th>}
                {selectedColumns.includes('Building_Code') && <th className="description-column">Building Code</th>}
                {selectedColumns.includes('Exptd_appnmt_of_Consultants') && <th className="description-column">Expected appointment of Consultants</th>}
                {selectedColumns.includes('Exptd_Handover_Date') && <th className="description-column">Expected Handover Date</th>}
                {selectedColumns.includes('Exptd_Authority_submissions') && <th className="description-column">Detailed Design and Authority Submission Start Date</th>}
                {selectedColumns.includes('Actual_Authority_submissions') && <th className="description-column"> Detailed Design and Authority Submission End Date</th>}
                {selectedColumns.includes('Contractor') && <th className="description-column">Contractor</th>}
                {selectedColumns.includes('Arch') && <th className="description-column">Arch</th>}
                {selectedColumns.includes('CS') && <th className="description-column">CS</th>}
                {selectedColumns.includes('ME') && <th className="description-column">M&E</th>}
                {selectedColumns.includes('QS') && <th className="description-column">QS</th>}
                {selectedColumns.includes('Remarks') && <th className="description-column">Remarks</th>}
                {selectedColumns.includes('tender_ref_no') && <th className="description-column">Tender_Ref_No</th>}
                {selectedColumns.includes('Submission_Remarks') && <th className="description-column">Submission Remarks</th>}
                {selectedColumns.includes('Project_Status_Remarks') && <th className="description-column">Project Status Remarks</th>}
              </tr>
            </thead>
            <tbody>
              {selectedColumns.length === 0 ? (
                <tr>
                  <td colSpan='46' style={{ height: '100px', padding: '20px' }}>Please Select any one column</td>
                </tr>
              )
                :
                rows.length === 0 ? (
                  <tr>
                    <td colSpan='46' style={{ height: '100px', padding: '20px' }}>{isLoading ? 'Loading...' : 'No records found'}</td>
                  </tr>
                )
                  :
                  (
                    rows.map((row, index) => (
                      <tr key={index}>
                        {selectedColumns.includes('Sno') && <td>{index + 1}</td>}
                        {selectedColumns.includes('SC_Number') && <td>{row.SC_Number}</td>}
                        {selectedColumns.includes('Proj_Name') && <td>{row.Proj_Name}</td>}
                        {selectedColumns.includes('Proj_ShortName') && <td>{row.Proj_ShortName}</td>}
                        {/* {selectedColumns.includes('Proj_ShortName') && <td>
                          <input
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            type="text"
                            value={row.Proj_ShortName}
                            onChange={(e) =>
                              handleEditField(index, 'Proj_ShortName', e.target.value)
                            }
                          />
                        </td>} */}
                        {/* {selectedColumns.includes('Proj_Number') && <td>{row.Proj_Number}</td>} */}
                        {/*{selectedColumns.includes('PM_Name') && <td>{row.PM_Name}</td>}
                        {selectedColumns.includes('PD_Name') && <td>{row.PD_Name}</td>}*/}
                        {selectedColumns.includes('PM_Name_New') && <td>{row.PM_Name_New}</td>}
                        {selectedColumns.includes('PD_Name_New') && <td>{row.PD_Name_New}</td>}
                        {selectedColumns.includes('Proj_Dept') && <td>{row.Proj_Dept}</td>}
                        {selectedColumns.includes('Proj_Address') && <td>{row.Proj_Address}</td>}
                        {selectedColumns.includes('CPRS_Number') && <td>{row.CPRS_Number}</td>}
                        {selectedColumns.includes('CPRS_Approval_Date') && <td>{formatDate(row.CPRS_Approval_Date)}</td>}
                        {selectedColumns.includes('Proj_Approved_Budget') && <td>{formatCurrency(row.Proj_Approved_Budget)}</td>}
                        {selectedColumns.includes('Proj_Cost') && <td>{formatCurrency(row.Proj_Cost)}</td>}
                        {selectedColumns.includes('Construction_Cost') && <td>{formatCurrency(row.Construction_Cost)}</td>}
                        {selectedColumns.includes('GFA') && <td>{row.GFA}</td>}
                        {selectedColumns.includes('Proj_StartDate') && <td>{row.Proj_StartDate}</td>}
                        {selectedColumns.includes('Proj_EndDate') && <td>{row.Proj_EndDate}</td>}
                        {selectedColumns.includes('Exptd_Cons_StartDate') && <td>{formatDate_n(row.Exptd_Cons_StartDate)}</td>}
                        {selectedColumns.includes('Exptd_Cons_EndDate') && <td>{formatDate_n(row.Exptd_Cons_EndDate)}</td>}
                        {selectedColumns.includes('Exptd_Main_Contractor_Calling_Date') && <td>{formatDate_n(row.Exptd_Main_Contractor_Calling_Date)}</td>}
                        {selectedColumns.includes('Exptd_Main_Contract_Award_Date') && <td>{formatDate_n(row.Exptd_Main_Contract_Award_Date)}</td>}
                        {selectedColumns.includes('Contractual_Cons_StartDate') && <td>{formatDate_n(row.Contractual_Cons_StartDate)}</td>}
                        {selectedColumns.includes('Contractual_Cons_EndDate') && <td>{formatDate_n(row.Contractual_Cons_EndDate)}</td>}
                        {/* {selectedColumns.includes('Exptd_Cons_StartDate') && <td>
                          <DatePicker
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.Exptd_Cons_StartDate ? parseISO(row.Exptd_Cons_StartDate, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'Exptd_Cons_StartDate', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </td>}

                        {selectedColumns.includes('Exptd_Cons_EndDate') && <td>
                          <DatePicker
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.Exptd_Cons_EndDate ? parseISO(row.Exptd_Cons_EndDate, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'Exptd_Cons_EndDate', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </td>}

                        {selectedColumns.includes('Exptd_Main_Contractor_Calling_Date') && <td>
                          <DatePicker
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.Exptd_Main_Contractor_Calling_Date ? parseISO(row.Exptd_Main_Contractor_Calling_Date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'Exptd_Main_Contractor_Calling_Date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </td>}

                        {selectedColumns.includes('Exptd_Main_Contract_Award_Date') && <td>
                          <DatePicker
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.Exptd_Main_Contract_Award_Date ? parseISO(row.Exptd_Main_Contract_Award_Date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'Exptd_Main_Contract_Award_Date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </td>}

                        {selectedColumns.includes('Contractual_Cons_StartDate') && <td>
                          <DatePicker
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.Contractual_Cons_StartDate ? parseISO(row.Contractual_Cons_StartDate, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'Contractual_Cons_StartDate', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </td>}

                        {selectedColumns.includes('Contractual_Cons_EndDate') && <td>
                          <DatePicker
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.Contractual_Cons_EndDate ? parseISO(row.Contractual_Cons_EndDate, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'Contractual_Cons_EndDate', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </td>} */}

                        {selectedColumns.includes('Actual_Cons_EndDate') && <td>{formatDate_n(row.Actual_Cons_EndDate)}</td>}
                        {selectedColumns.includes('Proj_Stage') && <td>{row.Proj_Stage}</td>}
                        {selectedColumns.includes('Proj_Progress_Status') && <td>{(row.Proj_Progress_Status*100)?.toFixed(2)}</td>}
                        {selectedColumns.includes('Potential_Extn_of_Time') && <td>{row.Potential_Extn_of_Time}</td>}
                        {selectedColumns.includes('Granted_Extn_of_Time') && <td>{row.Granted_Extn_of_Time}</td>}
                        {selectedColumns.includes('CSC_Date') && <td>{formatDate_n(row.CSC_Date)}</td>}
                        {selectedColumns.includes('Handover_Date') && <td>{formatDate_n(row.Handover_Date)}</td>}
                        {selectedColumns.includes('TOP_Date') && <td>{formatDate_n(row.TOP_Date)}</td>}
                        {selectedColumns.includes('DLP_Expiry_Date') && <td>{formatDate_n(row.DLP_Expiry_Date)}</td>}
                        {/* {selectedColumns.includes('Potential_Extn_of_Time') && <td>
                          <input
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            type="number"
                            value={row.Potential_Extn_of_Time || 0}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              const parsedValue = isNaN(newValue) ? 0 : parseInt(newValue, 10);
                              handleEditField(index, 'Potential_Extn_of_Time', parsedValue);
                            }}
                          />
                        </td>}

                        {selectedColumns.includes('Granted_Extn_of_Time') && <td>
                          <input
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            type="number"
                            value={row.Granted_Extn_of_Time || 0}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              const parsedValue = isNaN(newValue) ? 0 : parseInt(newValue, 10);
                              handleEditField(index, 'Granted_Extn_of_Time', parsedValue);
                            }}
                          />
                        </td>}

                        {selectedColumns.includes('CSC_Date') && <td>
                          <DatePicker
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.CSC_Date ? parseISO(row.CSC_Date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'CSC_Date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </td>}

                        {selectedColumns.includes('Handover_Date') && <td>
                          <DatePicker
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.Handover_Date ? parseISO(row.Handover_Date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'Handover_Date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />

                        </td>}
                        {selectedColumns.includes('TOP_Date') && <td>
                          <DatePicker
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.TOP_Date ? parseISO(row.TOP_Date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'TOP_Date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </td>}
                        {selectedColumns.includes('DLP_Expiry_Date') && <td>
                          <DatePicker
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.DLP_Expiry_Date ? parseISO(row.DLP_Expiry_Date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'DLP_Expiry_Date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </td>} */}
                        {selectedColumns.includes('Consultant_Names') && <td>{row.Consultant_Names}</td>}
                        {selectedColumns.includes('Contractor_Names') && <td>{row.Contractor_Names}</td>}
                        {selectedColumns.includes('Building_Code') && <td>{row.Building_Code}</td>}
                        {selectedColumns.includes('Exptd_appnmt_of_Consultants') && <td>{formatDate_n(row.Exptd_appnmt_of_Consultants)}</td>}
                        {selectedColumns.includes('Exptd_Handover_Date') && <td>{formatDate_n(row.Exptd_Handover_Date)}</td>}
                        {selectedColumns.includes('Exptd_Authority_submissions') && <td>{formatDate_n(row.Exptd_Authority_submissions)}</td>}
                        {selectedColumns.includes('Actual_Authority_submissions') && <td>{formatDate_n(row.Actual_Authority_submissions)}</td>}
                        {/* {selectedColumns.includes('Building_Code') && <td>
                          <input
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            type="text"
                            value={row.Building_Code}
                            onChange={(e) =>
                              handleEditField(index, 'Building_Code', e.target.value)
                            }
                          />
                        </td>}
                        {selectedColumns.includes('Exptd_appnmt_of_Consultants') && <td>
                          <DatePicker
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.Exptd_appnmt_of_Consultants ? parseISO(row.Exptd_appnmt_of_Consultants, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'Exptd_appnmt_of_Consultants', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </td>}
                        {selectedColumns.includes('Exptd_Handover_Date') && <td>
                          <DatePicker
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.Exptd_Handover_Date ? parseISO(row.Exptd_Handover_Date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'Exptd_Handover_Date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </td>}

                        {selectedColumns.includes('Exptd_Authority_submissions') && <td>
                          <DatePicker
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.Exptd_Authority_submissions ? parseISO(row.Exptd_Authority_submissions, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'Exptd_Authority_submissions', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </td>}

                        {selectedColumns.includes('Actual_Authority_submissions') && <td>
                          <DatePicker
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={row.Actual_Authority_submissions ? parseISO(row.Actual_Authority_submissions, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date==null)?date:format(date, 'yyyy-MM-dd');
                              handleEditField(index, 'Actual_Authority_submissions', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </td>} */}
                        {selectedColumns.includes('Contractor') && <td>{row.Contractor}</td>}
                        {selectedColumns.includes('Arch') && <td>{row.Arch}</td>}
                        {selectedColumns.includes('CS') && <td>{row.CS}</td>}
                        {selectedColumns.includes('ME') && <td>{row.ME}</td>}
                        {selectedColumns.includes('QS') && <td>{row.QS}</td>}
                        {selectedColumns.includes('Remarks') && <td>{row.Remarks}</td>}
                        {selectedColumns.includes('tender_ref_no') && <td>{row.tender_ref_no}</td>}
                        {selectedColumns.includes('Submission_Remarks') && <td>{row.Submission_Remarks}</td>}
                        {selectedColumns.includes('Project_Status_Remarks') && <td>{row.Project_Status_Remarks}</td>}
                        {/* {selectedColumns.includes('Remarks') && <td> 
                          <textarea
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            type="text"
                            value={row.Remarks}
                            onChange={(e) =>
                              handleEditField(index, 'Remarks', e.target.value)
                            }
                          />
                        </td>}
                        
                        {selectedColumns.includes('tender_ref_no') && <td> 
                          <input
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            type="text"
                            value={row.tender_ref_no}
                            onChange={(e) =>
                              handleEditField(index, 'tender_ref_no', e.target.value)
                            }
                          />
                        </td>}
                        {selectedColumns.includes('Submission_Remarks') && <td> 
                          <textarea
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            type="text"
                            value={row.Submission_Remarks}
                            onChange={(e) =>
                              handleEditField(index, 'Submission_Remarks', e.target.value)
                            }
                          />
                        </td>}
                        {selectedColumns.includes('Project_Status_Remarks') && <td> 
                          <textarea
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            type="text"
                            value={row.Project_Status_Remarks}
                            onChange={(e) =>
                              handleEditField(index, 'Project_Status_Remarks', e.target.value)
                            }
                          />
                        </td>} */}
                      </tr>
                    ))
                  )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ProjectMasterList;
